import { gql } from '@/__generated__';

export const StreamPostCardFragment = gql(`
fragment StreamPostCardFragment on StreamPost {
  ...BaseStreamPostCardFragment
  matchAiFilter
  authorId
  sourceId
  sourcePostId
  author {
    ...PostCardAuthorFragment
    __typename
  }
  stream {
    id
    label
    isEmpty
    paidData {
      id
    }
    __typename
  }
  __typename
}
`);
